import React from 'react';
import { Check } from 'lucide-react';
import { InlineCTA } from './InlineCTA';
export function TransformationSection() {
  const bullets = ['Te sientes menos perdida en público', 'Reaccionas con más claridad y menos culpa', 'Entiendes mejor qué dispara a tu hijo', 'Las crisis se vuelven más manejables', 'Recuperas confianza como mamá'];
  return <section className="bg-white pt-4 pb-2 md:py-24 px-5" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-[#2D1F0E] mb-6" data-id="element-156">
          Lo que cambia cuando dejas de improvisar
        </h2>

        <div className="bg-[#FDF8F0] rounded-3xl p-6 md:p-10 border border-[#D4A853]/20" data-id="element-157">
          <ul className="space-y-3 md:space-y-4" data-id="element-158">
            {bullets.map((bullet, idx) => <li key={idx} className="flex items-center gap-3 md:gap-4" data-id="element-159">
                <div className="bg-[#4A6741]/10 p-1.5 md:p-2 rounded-full flex-shrink-0" data-id="element-160">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-[#4A6741]" data-id="element-161" />
                </div>
                <span className="text-base md:text-lg text-[#2D1F0E] font-medium" data-id="element-162">
                  {bullet}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mt-4 md:mt-8" data-id="element-163">
          <InlineCTA text="Sí, quiero dejar de improvisar" data-id="element-164" />
        </div>
      </div>
    </section>;
}